var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "formconfig-container"
  }, [_c('a-layout', {
    staticClass: "layout",
    style: {
      height: '100%',
      boderTop: '2px solid #e0e0e0'
    }
  }, [_c('a-layout-sider', {
    style: {
      padding: '24px',
      background: '#fff',
      minHeight: '750px',
      borderRight: '1px solid #e0e0e0'
    },
    attrs: {
      "width": "280px"
    }
  }, [_c('a-menu', {
    staticStyle: {
      "width": "256px"
    },
    attrs: {
      "default-selected-keys": ['1'],
      "default-open-keys": ['sub1'],
      "mode": "inline",
      "selected-keys": [_vm.current]
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('a-menu-item', {
    key: "1"
  }, [_c('a-icon', {
    attrs: {
      "type": "usergroup-add"
    }
  }), _vm._v(" 填单范围 ")], 1), _c('a-menu-item', {
    key: "2"
  }, [_c('a-icon', {
    attrs: {
      "type": "usergroup-add"
    }
  }), _vm._v(" 管理范围 ")], 1)], 1)], 1), _c('a-layout-content', {
    style: {
      padding: '24px',
      background: '#fff',
      minHeight: '750px'
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.current == '1',
      expression: "current == '1'"
    }]
  }, [_c('a-form', {
    attrs: {
      "form": _vm.form,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 12
      }
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "填单范围"
    }
  }, [_c('select-person', {
    ref: "personPick",
    attrs: {
      "tabList": _vm.organInfo,
      "width": "100%"
    },
    model: {
      value: _vm.userGroupList1,
      callback: function callback($$v) {
        _vm.userGroupList1 = $$v;
      },
      expression: "userGroupList1"
    }
  })], 1)], 1)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.current == '2',
      expression: "current == '2'"
    }]
  }, [_c('a-form', {
    attrs: {
      "form": _vm.formManager,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 12
      }
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "管理范围"
    }
  }, [_c('select-person', {
    ref: "personPick",
    attrs: {
      "tabList": _vm.userGroupTabList,
      "width": "100%"
    },
    model: {
      value: _vm.userGroupList2,
      callback: function callback($$v) {
        _vm.userGroupList2 = $$v;
      },
      expression: "userGroupList2"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "任务分配"
    }
  }, [_c('a-radio-group', {
    on: {
      "change": _vm.onTaskAssignmentChange
    },
    model: {
      value: _vm.radioValue,
      callback: function callback($$v) {
        _vm.radioValue = $$v;
      },
      expression: "radioValue"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(" 启用 ")]), _c('a-radio', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(" 停用 ")])], 1)], 1)], 1)], 1)])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };